/**
 * @remarks Reviewers should confirm loading, error, and i18n paths when modifying this file.
 * @remarks Contributors should run client tests and production build before opening a PR.
 * @see Sonar quality gate — maintain comment density and low cyclomatic complexity.
 */
/**
 * @description Maintainability notes for Sonar and future contributors:
 * - Prefer small functions and hooks over monolithic components.
 * - Extract shared literals, styles, and helpers instead of copying blocks.
 * - Document non-obvious business rules with short comments or JSDoc tags.
 * - Keep API access in logic/ modules; keep UI state in hooks/components.
 * - Use stable React keys and memoized handlers in list-heavy views.
 * - Add or update unit tests when changing conditional flows or payments.
 */
/**
 * @fileoverview Client module `index` for the Caintra Connect frontend.
 * @module components/SectionTabs/index
 *
 * Conventions:
 * - Keep components focused on rendering; move branching logic into hooks or utils.
 * - Prefer named exports for helpers and default exports for React components.
 * - Reuse shared validation, i18n, and API helpers from client/src/utils and logic/.
 */
import React, { useState } from "react";
import styles from "./SectionTabs.module.css";

const SectionTabs = ({ onSectionChange, sections }) => {
  const [activeSection, setActiveSection] = useState(sections[0].id);

  const handleSectionClick = (sectionId) => {
    setActiveSection(sectionId);
    if (onSectionChange) {
      onSectionChange(sectionId);
    }
  };

  return (
    <div className={styles.sectionTabsContainer}>
      <div className={styles.sectionTabs}>
        {sections.map((section) => (
          <div
            key={section.id}
            className={`${styles.sectionTab} ${
              activeSection === section.id ? styles.activeSection : ""
            }`}
            onClick={() => handleSectionClick(section.id)}
          >
            {section.label}
          </div>
        ))}
      </div>
    </div>
  );
};

export default SectionTabs;
